import React from "react";
import PropTypes from "prop-types";
import { Box, Paper, Typography } from "@mui/material";
import ChartDateFilterBar from "./ChartDateFilterBar";
import {
  DASHBOARD_CHART_CONTENT_MAX_WIDTH,
  dashboardFiltersLabelSx,
  dashboardFiltersShellTransitionSx,
  dashboardFloatingCardSx,
} from "../dashboardChartStyles";

export function DashboardChartFilters({ alignToChartWidth = false }) {
  return (
    <Box
      sx={{
        ...dashboardFiltersShellTransitionSx,
        maxWidth: alignToChartWidth ? DASHBOARD_CHART_CONTENT_MAX_WIDTH : "100%",
      }}
    >
      <Paper elevation={0} sx={{ ...dashboardFloatingCardSx, width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", md: "nowrap" },
            alignItems: { xs: "flex-start", md: "center" },
            gap: { xs: 1.5, md: 2 },
            minWidth: 0,
          }}
        >
          <Typography component="h2" sx={dashboardFiltersLabelSx}>
            Filtri
          </Typography>
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              width: { xs: "100%", md: "auto" },
              display: "flex",
              justifyContent: { xs: "flex-start", md: "flex-end" },
            }}
          >
            <ChartDateFilterBar />
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}

DashboardChartFilters.propTypes = {
  alignToChartWidth: PropTypes.bool,
};
